
<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">參與店家 - {{campaignGroup.name}}</h4>
              </div>
              <div class="card-body">
                <!-- <router-link to="./gaa-users/new" type="success">
                  <n-button type="success">建立 GAA 管理員</n-button>
                </router-link>-->

                <div class="row">
                  <div class="col-md-12">
                    <el-row :gutter="20">
                      <el-col :xs="12" :md="3">
                        <router-link to="../../send-coupons" type="success">
                          <el-button type="warning" size="small">返回活動列表</el-button>
                        </router-link>
                      </el-col>
                    </el-row>
                    <hr />
                    <h5>活動總覽</h5>
                    <ul>
                      <li>
                        <strong>目前參與活動店家數：{{data.length}}</strong>
                      </li>
                      <li>
                        <strong>目前已匯入優惠券：{{voucherQty}}</strong>
                      </li>
                      <li>
                        <strong>目前已發出優惠券：{{sentQty}}</strong>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="card-header">
                <h5>贈送優惠券的店家列表</h5>
              </div>
              <div class="card-body">
                <el-row :gutter="20">
                  <el-col :xs="24" :md="6">
                    <el-input
                      v-model="filters[0].value"
                      size="small"
                      placeholder="搜尋店家"
                      prefix-icon="el-icon-search"
                    ></el-input>
                  </el-col>
                  <!-- <el-col :xs="24" :md="6">
                        <el-button
                          type="danger"
                          @click.native="openAddShopPage()"
                          size="small"
                          plain
                        >新增參與店家</el-button>
                  </el-col>-->
                  <el-col :xs="24" :md="6">
                    <router-link to="./add-shops" >
                      <el-button type="info" style="background-color: #0ABBF9;border-color: #0ABBF9;" size="small"><i class="el-icon-s-shop"></i>新增參與店家</el-button>
                    </router-link>
                    <!-- <router-link to="./add-shops" type="success">
                      <el-button type="danger" size="small" plain>批次匯入優惠券</el-button>
                    </router-link> -->
                  </el-col>
                  <el-col :xs="12" :md="3">
                    <ul>
                    <li>1. 勾選店家</li>
                    <li>2. 下載匯入範例 </li>
                    <li>3. 匯入優惠券</li>
                    </ul>
                  </el-col>
                  
                  <el-col :xs="12" :md="6">              
                    <el-button type="primary" size="small" @click.native="downloadExample()">下載匯入範例</el-button>
                    <el-button type="danger" size="small" @click.native="openImportPage()">批次匯入優惠券</el-button>
                    <!-- <router-link to="./add-shops" type="success">
                      <el-button type="danger" size="small" >批次匯入優惠券</el-button>
                    </router-link> -->
                    
                     <div v-if="dlError" style="color:#BA0000; margin: 10px 0 0 0;">
                        {{dlError}}
                      <i class="now-ui-icons ui-1_simple-remove"></i>
                    </div>
                  </el-col>
                </el-row>
                <data-tables :data="data" :filters="filters" :action-col="actionCol">
                  <el-table-column label="選擇" prop="id" sortable="custom">
                    <template slot-scope="scope">
                      <div class="checkbox-radios">
                        <checkbox v-model="scope.row.selected" class="pull-left" name="subscribe"></checkbox>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="狀態" prop="id" sortable="custom">
                    <template slot-scope="scope">
                      <span>
                      <n-switch style="margin:3px 0 0 0;" v-model="scope.row.enabled" @click.native="switchCampaign(scope.row.id, scope.$index)" color="green">
                      <i class="fa fa-check" slot="on"></i>
                      <i class="fa fa-exclamation" style="color:red;" slot="off"></i>
                      </n-switch>
                      </span>
                     
                      <span> {{scope.row.statusDisplay}}</span>
                      <!-- <el-button size="small" :type="scope.row.statusType" @click.native="switchCampaign(scope.row.id, scope.$index)"><i :class="scope.row.statusIcon"></i> {{scope.row.statusDisplay}}</el-button> -->
                      <!-- <div v-if="data[scope.$index].suspend">
                        <el-button size="small" type="default" style="background-color: #FFFFFF;" @click.native="enableCampaign(scope.row.id, scope.$index)"><i class="el-icon-open" style="font-size:1.1rem;  color:#BA0000;"></i> 暫停中</el-button>
                      </div>
                      <div v-else><el-button type="default" style="background-color: #FFFFFF;" size="small" @click.native="disableCampaign(scope.row.id, scope.$index)"><i class="el-icon-turn-off" style="font-size:1.1rem; color:#00BA00;"></i> 運作中</el-button></div> -->

                    </template>
                  </el-table-column>
                  <el-table-column
                    v-for="title in titles"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.prop"
                    sortable="custom"
                  ></el-table-column>
                </data-tables>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { Checkbox, Radio } from "src/components/index";
import {
  TimeSelect,
  DatePicker,
  Tag,
  Input,
  Button,
  Select,
  Option
} from "element-ui";
import {
  Switch,
  FormGroupInput as FgInput
} from "src/components/index";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    Checkbox,
    Radio,
    [Switch.name]: Switch,
    FgInput
  },
  data() {
    return {
      updateInfo: null,
      updateConditions: null,
      updateMessages: null,
      dlError: null,
      sentQty: 0,
      voucherQty: 0,
      campaignGroup: {
        startTime: "",
        endTime: "",
        conditions: []
      },
      startTime: "",
      endTime: "",
      conditions: {
        shopNewCheck: "N", // Y: 新戶only, N: 不限制
        paymentCheck: "N", // Q: Qrpay, N:不限制
        amountCheck: "N", // Y: 有低消, N: 不限制
        minConsumption: "0" // 數字：最低消費, '0': 不限制
      },
      data: [],
      titles: [
        {
          prop: "id",
          label: "活動ID"
        },
        {
          prop: "shopId",
          label: "商店ID"
        },
        {
          prop: "shopName",
          label: "店家名稱"
        },
        {
          prop: "total",
          label: "總數量"
        },
        {
          prop: "sent",
          label: "已發出"
        },
        {
          prop: "remain",
          label: "剩餘數"
        },
        // {
        //   prop: "statusDisplay",
        //   label: "是否啟用"
        // },
        {
          prop: "updatedAt",
          label: "加入時間"
        }
      ],
      actionCol: {
        label: "操作",
        props: {
          align: "center"
        },
        buttons: [
          {
            props: {
              type: "success",
              size: "small",
              icon: "el-icon-s-order"
            },
            label: "查看明細",
            handler: row => {
              console.log("the row is ", row);

              this.$router.push(`/send-coupons/${this.$route.params.groupId}/vouchers/${row.id}`);
            }
          }
        ]
      },
      filters: [
        {
          value: "",
          prop: "shopName"
        },
        {
          value: []
        }
      ]
    };
  },
  methods: {
    windowClosing() {
      // this.getSpecialOpenings();
      this.getCampaignGroups();
    },
    downloadExample() {
      
      this.dlError = null;
      let selected = [];
      let selectedStr = '';
      let first = true;
      for (let i = 0; i < this.data.length; ++i) {
        if (this.data[i].selected) {
          selected.push(this.data[i]);
          if (!first)
            selectedStr += ',';
          selectedStr += this.data[i].id;
          first = false;
        }
          
      }
      if (!selected.length) {
        this.dlError = '請勾選要匯入的店家';
        return;
      }
      let qs = encodeURI(`?shops=${selectedStr}`);
       window.open(`${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}/batch-import-example${qs}`, '_blank');
      // var newWindow = window.open(
      //   `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}/batch-import-example${qs}`,
      //   "_blank",
      //   "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=1000,height=1000"
      // );
      // // for same origin
      // // newWindow.onbeforeunload = this.windowClosing;

      // let self = this;
      // // for cross origin
      // var timer = setInterval(function() {
      //   if (newWindow.closed) {
      //     clearInterval(timer);
      //     self.windowClosing();
      //   }
      // }, 1000);
    },
    openImportPage: function() {
      // let qs = encodeURI(`?shop=${this.$route.query.shop_id}`);
      // var newWindow = window.open(
      //   `${process.env.VUE_APP_MENU}/opening-upload${qs}`,
      //   "upload-opening-setting",
      //   "width=200,height=100"
      //   // "width=300,location=no,menubar=no"
      // );
      var newWindow = window.open(
        `${process.env.VUE_APP_MENU}/#/shops/import-vouchers/${this.$route.params.groupId}`, 
        "", 
        "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=1000,height=1000");
      // for same origin
      // newWindow.onbeforeunload = this.windowClosing;

      let self = this;
      // for cross origin
      var timer = setInterval(function() {
        if (newWindow.closed) {
          clearInterval(timer);
          self.windowClosing();
        }
      }, 1000);
    },
    // openAddShopPage: function() {
    //   let qs = encodeURI(`?shops=${selectedStr}`);
    //   // var newWindow = window.open(
    //   //   `${process.env.VUE_APP_MENU}/opening-upload${qs}`,
    //   //   "upload-opening-setting",
    //   //   "width=200,height=100"
    //   //   // "width=300,location=no,menubar=no"
    //   // );
    //   var newWindow = window.open(
    //     `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}/batch-import-example${qs}`,
    //     "",
    //     "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=1000,height=1000"
    //   );
    //   // for same origin
    //   // newWindow.onbeforeunload = this.windowClosing;

    //   let self = this;
    //   // for cross origin
    //   var timer = setInterval(function() {
    //     if (newWindow.closed) {
    //       clearInterval(timer);
    //       self.windowClosing();
    //     }
    //   }, 1000);
    // },
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    switchCampaign(voucherId, index) {
      let self = this;
      // console.log('original ' + self.data[index].status);
      let status = (self.data[index].status === 'enabled' ? 'disabled' : 'enabled');
      let enabled = (self.data[index].status === 'enabled' ? true : false);
      self.data[index].status = status;
      self.data[index].enabled = enabled;
      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}/vouchers/${voucherId}/status`,
          {
            status: status
          }
        )
        .then(response => {
          self.getCampaignGroups();
        });
    },
    // disableCampaign(voucherId, index) {

    //    return axios
    //     .put(
    //       `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}/vouchers/${voucherId}/status`,
    //       {
    //         status: 'disabled'
    //       }
    //     )
    //     .then(response => {
    //       console.log('go change ' + JSON.stringify(this.data[index]));
    //       // this.data[index].status = 'disabled';
    //       this.data[index].statusDisplay = '暫停中';
    //       // this.data[index].statusIcon = 'el-icon-close';
    //       // this.data[index].statusType = 'danger';
    //       console.log('result ' + JSON.stringify(this.data));
    //       return response.data;
    //     });
    // },
    formatCampaign() {
      let self = this;
      // 處理conditions
      for (let i = 0; i < self.campaignGroup.conditions.length; ++i) {
        switch (self.campaignGroup.conditions[i].name) {
          case "paymentCheck":
            self.conditions.paymentCheck = "Q";
            // this.campaignGroup.conditions[i] = {
            //   derivation: "{{IF(order.paymentTypes !== 'cash','Y','N')}}",
            //   eval: false
            // }
            break;
          case "shopNewCheck":
            self.conditions.shopNewCheck = "Y";
            break;
          case "amountCheck":
            self.conditions.amountCheck = "Y";
            self.conditions.minConsumption =
              self.campaignGroup.conditions[i].value || 0; // 另外拉出來做成參數比較好做
            break;
        }
      }
      // this.campaignGroup.conditions;
      this.startTime = moment.unix(self.campaignGroup.startTs).toISOString();
      // .format("YYYY-MM-DD HH:mm:ss Z");

      this.endTime = moment.unix(self.campaignGroup.endTs).toISOString();

      // .format("YYYY-MM-DD HH:mm:ss Z");
      return;
    },
    getCampaignDetail() {
      let self = this;
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}`
        )
        .then(response => {
          this.campaignGroup = response.data || {};

          console.log(
            "the campaign group " + JSON.stringify(self.campaignGroup)
          );
          this.formatCampaign();
          console.log("our conditions " + JSON.stringify(self.conditions));
          return response.data;
        });
    },
    // getOverview() {
    //   return axios
    //     .get(
    //       `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}/overview`
    //     )
    //     .then(response => {
    //       // this.campaignGroup = response.data || {};

    //       let totalMap = {};
    //       for (let i = 0; i < response.total.length; ++i) {
    //         totalMap[response.total[i].campaignId] = response.total[i].codeCount;
    //       }

    //       let sentMap = {};
    //       for (let i = 0; i < response.sent.length; ++i) {
    //         sentMap[response.sent[i].campaignId] = response.sent[i].sentCount;
    //       }

    //       return response.data;
    //     });
    // },
    getCampaignGroups() {
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}/campaigns`
        )
        .then(response => {
          this.data = response.data;
          this.voucherQty = 0;
          this.sentQty = 0;
          for (let a of this.data) {
            a.updatedAt = moment
              .unix(a.updatedTs)
              .format("YYYY-MM-DD HH:mm:ss Z");

            a.enabled = (a.status === 'enabled' ? true : false);
            a.statusDisplay = a.status === "disabled" ? '暫停中' : '運作中';
            // a.statusType = a.status === "disabled" ? 'danger': 'success';
            // a.statusIcon = a.status === "disabled" ? 'el-icon-close': 'el-icon-open';
            
            a.remain = a.total - a.sent;
            this.voucherQty += a.total;
            this.sentQty += a.sent;
          }
          return response.data;
        });
    },
    saveInfo() {
      // console.log("the campaign group " + JSON.stringify(this.campaignGroup));
      this.updateInfo = "updating";
      this.campaignGroup.startTs = moment(this.startTime).unix();
      this.campaignGroup.endTs = moment(this.endTime).unix();

      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}`,
          {
            name: this.campaignGroup.name,
            startTs: this.campaignGroup.startTs,
            endTs: this.campaignGroup.endTs
          }
        )
        .then(response => {
          this.updateInfo = "success";

          this.campaignGroup = response.data || {};
          this.formatCampaign();

          // console.log(response.data);
          return response.data;
        })
        .catch(e => {
          console.log(e.stack);
          this.updateInfo = "error";
        });
    },
    saveConditions() {
      this.updateConditions = "updating";
      let conditions = [];
      let matching = "";
      let matchFirst = true;
      if (this.conditions.shopNewCheck === "Y") {
        conditions.push({
          name: "shopNewCheck",
          derivation: "{{IF(order.isShopNew === true, 'Y', 'N')}}",
          eval: false
        });
        if (!matchFirst) matching += " && ";
        matching += "compute.shopNewCheck == 'Y'";
        matchFirst = false;
      }

      if (this.conditions.paymentCheck == "Q") {
        conditions.push({
          name: "paymentCheck",
          derivation: "{{IF(order.paymentTypes !== 'cash','Y','N')}}",
          eval: false
        });

        if (!matchFirst) matching += " && ";
        matching += "compute.shopNewCheck == 'Y'";
        matchFirst = false;
      }

      if (this.conditions.amountCheck == "Y") {
        conditions.push({
          name: "amountCheck",
          derivation: `{{IF(order.amount > ${this.conditions.minConsumption ||
            0}, 'Y','N')}}`,
          value: this.conditions.minConsumption || 0,
          eval: false
        });
        if (!matchFirst) matching += " && ";
        matching += "compute.amountCheck == 'Y'";
        matchFirst = false;
      }

      let matchingDerivation = `{{IF(${matching}, 'Y', 'N')}}`;
      conditions.push({
        name: "matching",
        derivation: matchingDerivation,
        eval: false
      });
      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}/conditions`,
          {
            conditions: conditions
          }
        )
        .then(response => {
          this.updateConditions = "success";

          this.campaignGroup = response.data || {};
          this.formatCampaign();

          // console.log(response.data);
          return response.data;
        })
        .catch(e => {
          console.log(e.stack);
          this.updateConditions = "error";
        });
    },
    saveMessages() {
      this.updateMessages = "updating";

      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.groupId}/messages`,
          {
            voucherMessage: this.campaignGroup.voucherMessage,
            fullQuotaMessage: this.campaignGroup.fullQuotaMessage
          }
        )
        .then(response => {
          this.updateMessages = "success";

          this.campaignGroup = response.data || {};
          this.formatCampaign();

          console.log(response.data);
          return response.data;
        })
        .catch(e => {
          console.log(e.stack);
          this.updateMessages = "error";
        });
    }
  },
  mounted() {
    this.getCampaignDetail();
    this.getCampaignGroups();
    // this.getOverview();
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
.k-form-label {
  margin: 5px 0 0 0;
}
.k-form-group {
  margin: 10px 0 10px 0;
}
/* .k-input input { */
/* margin: 10px; */
/* width: 100px; */
/* height: 30px; */
/* } */
</style>